"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplyType = void 0;
var SupplyType;
(function (SupplyType) {
    SupplyType["WORKPIECES"] = "workpieces";
    SupplyType["DETAILS"] = "details";
})(SupplyType = exports.SupplyType || (exports.SupplyType = {}));
//# sourceMappingURL=supply.type.js.map